import { render, staticRenderFns } from "./abroad-social-new.vue?vue&type=template&id=a4f799e2&scoped=true&"
import script from "./abroad-social-new.vue?vue&type=script&lang=js&"
export * from "./abroad-social-new.vue?vue&type=script&lang=js&"
import style0 from "./abroad-social-new.vue?vue&type=style&index=0&id=a4f799e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f799e2",
  null
  
)

export default component.exports